import React from 'react';
import Typography from '@mui/material/Typography';

export default function PresenceShiftTimes({shifts = []}) {
  return (shifts || []).map(shift => {
    const formatter = new Intl.DateTimeFormat('en-GB', {
      hour: '2-digit', minute: '2-digit', timeZone: shift.timeZone || 'Europe/London'
    });
    const time = value => {
      const date = value ? new Date(value) : null;
      return date && !Number.isNaN(date.getTime()) ? formatter.format(date) : null;
    };
    const start = time(shift.clockInTime) || time(shift.startTime);
    const end = time(shift.clockOutTime) || time(shift.endTime);
    if (!start && !end) return null;
    return <Typography variant="body2" key={shift._id || shift.plandayShiftId}>
      {start || '—'} – {end || '—'}
    </Typography>;
  });
}
